// pages/Login.jsx
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//import logo from '../images/logo.png';
import { AuthContext } from "../context/AuthContext";
import api from '../api';
import Footer from '../components/Footer';
//

const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
    const { login } = useContext(AuthContext); // 🔹 utilise le context


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/api/auth/login', form);
     
      login(res.data); // ⚡ met à jour le state global et localStorage
      navigate("/dashboard"); 
    } catch (error) {
      alert(error?.response?.data?.msg || "Erreur de connexion");
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--app-background)' }}>
      {/* Header */}
      <header className="p-4 text-center border-b bg-white">
        {/* <img src={logo} alt="Logo" className="h-10 mx-auto" /> */}
      </header>

      {/* Main */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Connexion
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              name="email"
              placeholder="Adresse email"
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
            />

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Mot de passe"
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3 pr-10 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--button-primary)] hover:text-[var(--button-primary-hover)]"
              >
                {showPassword ? "🙈" : "👁"}
              </button>
            </div>

            <div className="text-right">
              <p
                className="text-sm link-accent cursor-pointer"
                onClick={() => navigate('/forgot-password')}
              >
                Mot de passe oublié ?
              </p>
            </div>

            <button
              type="submit"
              className="w-full btn-primary py-3 font-semibold"
            >
              Se connecter
            </button>
          </form>

          <p className="text-center text-gray-600 mt-6">
            Pas encore de compte ?{' '}
            <span
              onClick={() => navigate('/register', { state: { preselectedRole: 'particulier' } })}
              className="link-accent font-medium cursor-pointer"
            >
              S’inscrire
            </span>
          </p>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Login;




